function b() {
  return (b = Object.assign || function(e) {
    var c, d, a;
    for (c = 1; c < arguments.length; c++) {
      d = arguments[c];
      for (a in d) {
        Object.prototype.hasOwnProperty.call(d, a) && (e[a] = d[a]);
      }
    }
    return e;
  }).apply(this, arguments);
}

export { b as _ };
//# sourceMappingURL=5301ccd2.mjs.map
